module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "news-list-panel"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.filteredNewsList.length === 0) ? _c('div', {
    staticClass: "panel-content"
  }, [_c('spinner')], 1) : _c('div', {
    staticClass: "panel-content"
  }, [_vm._l((_vm.filteredNewsList), function(item) {
    return _c('div', {
      staticClass: "news"
    }, [_c('div', {
      staticClass: "row columns"
    }, [_c('div', {
      staticClass: "medium-4 columns"
    }, [(item.featured_image) ? _c('router-link', {
      attrs: {
        "id": "news-list-img-link",
        "to": {
          name: 'NewsDetail',
          params: {
            id: item.id.toString()
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.featured_image,
        "alt": "aperçu"
      }
    })]) : _c('router-link', {
      attrs: {
        "id": "news-list-img-link",
        "to": {
          name: 'NewsDetail',
          params: {
            id: item.id.toString()
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "http://lorempixel.com/640/480/",
        "alt": "aperçu"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "medium-8 columns"
    }, [_c('router-link', {
      attrs: {
        "id": "news-list-title-link",
        "to": {
          name: 'NewsDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('h4', {
      staticClass: "news-title"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      staticClass: "news-infos"
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("par " + _vm._s(item.user.username))]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-calendar",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("le " + _vm._s(_vm._f("formatDate")(item.created)))]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-comments",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.comments_count) + " commentaires")]), _vm._v(" "), _c('span', [_c('i', {
      staticClass: "fa fa-heart",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(item.likes) + " likes")])]), _vm._v(" "), _c('div', {
      staticClass: "abstract"
    }, [_vm._v("\n                      " + _vm._s(item.description) + "\n                      ")])], 1)]), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "large-5 column"
  }, [_c('router-link', {
    staticClass: "left-bottom-link",
    attrs: {
      "id": "news-list-bottom-link",
      "to": {
        name: 'NewsList'
      }
    }
  }, [_vm._v("Toutes les actualités...")])], 1), _vm._v(" "), _c('div', {
    staticClass: "large-7  column"
  }, [_c('paginate', {
    attrs: {
      "click-handler": _vm.paginateClickCallback,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "page-count": _vm.pageCount,
      "container-class": 'pagination'
    }
  })], 1)])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n        Autres actualités\n        "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b6b75e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/news-list-panel.vue
// module id = 715
// module chunks = 0